import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchStockReturnDetail(id) {
  const { data: raw } = await request.get(`/ims/stock-return/${id}`);
  return parseVer4DetailResponse(raw);
}
